import { MessageBar, MessageBarType, Spinner } from "@fluentui/react";

import { AdminDevConsole } from "../../components/AdminDevConsole";
import { useAdminAccess } from "../../hooks/useAdminAccess";
import styles from "./AdminConsolePage.module.css";

const AdminConsolePage = () => {
    const { isAdmin, isLoading } = useAdminAccess();

    if (isLoading) {
        return (
            <div className={styles.centered}>
                <Spinner label="Checking admin access..." />
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <div className={styles.centered}>
                <MessageBar className={styles.message} messageBarType={MessageBarType.blocked} isMultiline={true}>
                    You do not have access to the admin console.
                </MessageBar>
            </div>
        );
    }

    return <AdminDevConsole />;
};

export default AdminConsolePage;
